import script from "./GstProblem.vue?vue&type=script&setup=true&lang=js"
export * from "./GstProblem.vue?vue&type=script&setup=true&lang=js"

import "./GstProblem.vue?vue&type=style&index=0&id=525fd94f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525fd94f"]])

export default __exports__